<template>
  <v-autocomplete
    :items="clientList"
    item-value="id"
    item-text="name"
    v-model="clientIdValue"
    label="Client"
    :clearable="clearable ? clearable : false"
    :readonly="readonly"
    :disabled="disabled"
    :rules="[requiredCheck()]"
    :dense="dense"
    :hide-details="hideDetails ? hideDetails : false"
    outlined
  ></v-autocomplete>
</template>

<script>
import { mapActions } from 'vuex'
import { required } from '@/lib/formValidations'

export default {
  props: [
    'id',
    'businessEntityId',
    'isRequired',
    'readonly',
    'disabled',
    'clearable',
    'dense',
    'hideDetails'
  ],
  data () {
    return {
      clientList: []
    }
  },
  computed: {
    clientIdValue: {
      get () {
        return this.id
      },
      set (newValue) {
        this.$emit('clientIdChange', newValue)
      }
    }
  },
  watch: {
    businessEntityId () {
      this.loadClientOptions()
    }
  },
  methods: {
    ...mapActions('clients', [
      'getClientOptions'
    ]),
    loadClientOptions () {
      const filters = {}

      if (this.businessEntityId !== null && this.businessEntityId !== undefined) {
        filters.businessEntityId = this.businessEntityId
      }

      this.getClientOptions(filters).then((clients) => {
        this.clientList = clients
      })
    },
    requiredCheck () {
      return !this.isRequired || required('Client')
    }
  },
  created () {
    this.loadClientOptions()
  }
}
</script>
